import { Box, Card, Container, Divider, Grid, Group, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconMail, IconMapPin, IconPhone } from '@tabler/icons-react';

const PRIMARY = '#FF8A00';

export default function ContactPage() {
  return (
    <Container p='20px 15px 20px 20px'>
      {/* Page Title */}
      <Stack spacing={6} mb='xl'>
        <Title order={2} fw={700}>
          Contact Us
        </Title>
        <Text size='sm' c='dimmed'>
          We’d love to hear from you
        </Text>
      </Stack>

      <Grid gutter='xl'>
        {/* Contact Info */}
        <Grid.Col md={12}>
          <Card
            radius='xl'
            p='xl'
            withBorder
            sx={{
              transition: 'all 0.2s ease',
              '&:hover': {
                boxShadow: '0 10px 30px rgba(0,0,0,0.06)',
              },
            }}>
            <Stack spacing='lg'>
              <Box>
                <Title order={4} fw={600}>
                  Get in touch
                </Title>
                <Text size='sm' c='dimmed' mt={4}>
                  Have questions or need help? Our team is here to assist you. Reach out and we’ll respond as soon as
                  possible.
                </Text>
              </Box>

              <Divider />

              {/* Address */}
              <Group align='flex-start' spacing='md'>
                <ThemeIcon radius='xl' size={42} color='orange' variant='light'>
                  <IconMapPin size={20} />
                </ThemeIcon>
                <Box>
                  <Text fw={500}>Address</Text>
                  <Text size='sm' c='dimmed'>
                    88 Market Drive
                    <br />
                    Santa Ana, CA 92703
                  </Text>
                </Box>
              </Group>

              {/* Email */}
              <Group align='flex-start' spacing='md'>
                <ThemeIcon radius='xl' size={42} color='orange' variant='light'>
                  <IconMail size={20} />
                </ThemeIcon>
                <Box>
                  <Text fw={500}>Email</Text>
                  <Text size='sm' c='dimmed'>
                    info@clamortogo.com
                  </Text>
                </Box>
              </Group>

              {/* Phone */}
              <Group align='flex-start' spacing='md'>
                <ThemeIcon radius='xl' size={42} color='orange' variant='light'>
                  <IconPhone size={20} />
                </ThemeIcon>
                <Box>
                  <Text fw={500}>Phone</Text>
                  <Text size='sm' c='dimmed'>
                    +1 (714) 955-1940
                  </Text>
                </Box>
              </Group>
            </Stack>
          </Card>
        </Grid.Col>

        {/* Optional Contact Form (when you enable it) */}
        {/*
        <Grid.Col md={7}>
          <Card radius="xl" p="xl" withBorder>
            <Stack spacing="md">
              <Title order={4}>Send us a message</Title>

              <TextInput
                label="Full Name"
                placeholder="Enter your name"
                radius="md"
              />

              <TextInput
                label="Email"
                placeholder="Enter your email"
                radius="md"
              />

              <Textarea
                label="Message"
                placeholder="Write your message..."
                minRows={4}
                radius="md"
              />

              <Group justify="flex-end" mt="md">
                <Button
                  radius="md"
                  size="md"
                  color="orange"
                >
                  Send Message
                </Button>
              </Group>
            </Stack>
          </Card>
        </Grid.Col>
        */}
      </Grid>
    </Container>
  );
}
